angular.module('workerStatusModule', [])
	.controller('dataPipelineJobStatus', function($scope, $timeout, $location, $experiments, dataPipelineJobStatusService, dateFilter) {

		$scope.type = $location.search().type;
		$scope.header = 'Lean Load';
		if ($scope.type === 'LeanSync') {
			$scope.header = 'Lean Sync';
		} else if ($scope.type === 'LeanTransform') {
			$scope.header = 'Lean Transform';
		} else if ($scope.type === 'Procurement') {
			$scope.header = 'Analytics';
		} else if ($scope.type === 'LeanDNA Connect') {
			$scope.header = 'LeanDNA Connect';
		}
		$scope.header += ' Detailed Status';
		$scope.displayed = [];
		$scope.factory = ($location.search()).factory;
		$scope.factoryNdx= ($location.search()).factoryNdx;
		$scope.state = ($location.search()).lsState;

		$scope.factoryHref = '/application/f/home.html#/setup/data-pipeline-history?&factoryNdx=' + $scope.factoryNdx;
		$scope.summaryHref = '/application/f/home.html#/setup/data-pipeline';

		$timeout(function(){
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#supplyChainDataPipeline').addClass('selected');
		}, 0);

		$scope.exportCSV = function(row, type) {
			dataPipelineJobStatusService.exportCSV($scope, row, type);
		};

		$scope.callServer = function callServer() {
			$scope.isLoading = true;
			$scope.jobId = ($location.search()).jobId;
			dataPipelineJobStatusService.getLeanSync($scope.jobId, $scope.factoryNdx).then(
				function(result) {
					if (result.data) {
						// For leanload, remove the '_1' at the end of the step name
						for  (var i = 0; i < result.data.length; i++) {
							var row = result.data[i];
							// a simple sorting solution for null values in bytesScanned
							if (!row.bytesScanned && row.bytesScanned !== 0) {
								row.bytesScanned = -1;
							}

							if ($scope.type === 'LeanLoad') {
								row.name = row.name.substring(0, row.name.length - 2);
							}
							if (row.dateEnd && row.dateStart) {
								var dateEnd = new Date(row.dateEnd);
								var dateStart = new Date(row.dateStart);
								row.durationInMs = moment(dateEnd).diff(moment(dateStart));
								row.durationStr = moment.utc(row.durationInMs).format('HH:mm:ss');
							}
						}
					}
					$scope.displayed = result.data;
					$scope.isLoading = false;
				}
			);
		};

		$timeout(function () {
			$scope.callServer();
		}, 0);
	})

	.service('dataPipelineJobStatusService', function($filter, $timeout, $http, excelExportService) {
		return {
			getLeanSync: getLeanSync,
			exportCSV: exportCSV
		};

		function getLeanSync(jobId, factoryNdx) {
			// TODO: Error handling
			return $http.get('/api/2/factndx/' + factoryNdx + '/WorkerQueue/Job/' + jobId + '/LeanSyncStep');
		}

		function exportCSV(scope, row, type) {
			var modalScope = scope.$new();
			var url = '/api/2/factndx/' + row.factoryNdx + '/WorkerQueue/Job/' + row.jobId + '/' + type + 'Step/' + row.name + '/DroppedRows';
			excelExportService.getExcelReportWithGet(row.factoryNdx, url, modalScope, undefined, true);
		}
	});
